import * as angular from "angular";

angular
  .module('bringoz.admin.commons')
  .constant('Location_PN', {
    database: 'locations',
    isBranchEntity: false
  });
